export default {"src":"/frontend-static/_next/static/media/size-guide.c59a0169.svg","height":83,"width":140,"blurWidth":0,"blurHeight":0};